export default __webpack_public_path__ + "static/media/star_shape.69b839da.svg";